import { useParams } from "react-router-dom";
import { useGetBookQuery } from "../../redux/features/api/apiSlice";
import Error from "../ui/Error";
import Form from "./Form";

export default function EditBook() {
  const { bookId } = useParams();
  const { data: book, isLoading, isError } = useGetBookQuery(bookId);

  let content = null;
  if (isLoading) {
    content = <div>Loading...</div>;
  }

  if (!isLoading && isError) {
    content = <Error message="There was an error while editing!" />;
  }

  if (!isLoading && !isError && book?.id) {
    content = <Form book={book} />;
  }

  return (
    <>
      <h4 className="mb-8 text-xl font-bold text-center">Edit Book</h4>
      {content}
    </>
  );
}
